<template>
  <div>
    <Modal :config="reportModalConfig" @accept="updateReport()">
        <template slot="header">
            Rediger rapport
        </template>
        <template slot="content">
            <div class="form">
                <div class="grid-x align-items">
                    <div class="large-1 medium-1 small-2 cell flexbox-center">
                        <icon class="info small-svg" name="info"></icon>
                    </div>
                    <div class="auto cell border-bottom">
                        <div class="grid-x">
                            <div class="large-3 medium-3 small-5 cell flexbox-center-left">
                                <label for="remark">Navn</label>
                            </div>
                            <div class="auto cell">
                                <input type="text" name="Navn" title="Navn" v-model="selectedReport.navn">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form">
                <div class="grid-x align-items">
                    <div class="large-1 medium-1 small-2 cell flexbox-center">
                        <icon class="info small-svg" name="info"></icon>
                    </div>
                    <div class="auto cell border-bottom border-bottom-last">
                        <div class="grid-x">
                            <div class="large-3 medium-3 small-5 cell flexbox-center-left">
                                <label for="remark">Beskrivelse</label>
                            </div>
                            <div class="auto cell">
                                <input type="text" name="Beskrivelse" title="Beskrivelse" v-model="selectedReport.beskrivelse">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Modal>

    <!-- modal handler -->
    <Modal :config="handlerModalConfig">
        <template slot="header">
            {{handlerHeader}}
        </template>
    </Modal>

    <!-- report counter -->
    <div class="auto cell" style="margin-top: 15px;"></div> <!-- Dummy: for keep layout -->
    <div class="grid-x list-counter">
        <div v-if="reports.length > 0" class="flexbox-align-items">
            <span>{{reports.length}} rapport<span v-if="reports.length > 1">er</span></span>
        </div>
        <div v-else class="large-12 no-result">
            <div class="grid-x">
                <div class="large-12 cell">
                    <span>Ingen reporter, prøv med et andet:</span>
                    <ul>
                        <li>årstal</li>
                        <li>balance</li>
                    </ul>
                </div>
            </div>
            <div class="grid-x">
                <div class="large-12 no-result-img cell"></div>
            </div>
        </div>
    </div>

    <!-- report sort -->
    <div v-if="reports.length > 0" class="grid-x list-sort non-sortable">
        <div class="large-1 cell"></div>
        <div class="large-4 cell non-sortable item flexbox no-margin">
            <span>Navn</span>
        </div>
        <div class="large-6 cell non-sortable item flexbox no-margin">
            <span>Beskrivelse</span>
        </div>
        <div class="large-1 cell"></div>
    </div>

    <!-- report list -->
    <transition-group name="list" tag="div">
        <div v-for="report in reports" :key="report.id" class="cursor">
            <div class="grid-x list-row entity-icon-row align-items">
                <div @click="openReportDetails(report)" class="large-1 cell">
                    <icon class="larger-svg fill-primary-no-stroke" name="excel-icon"></icon>
                </div>
                <div @click="openReportDetails(report)" class="large-4 cell item truncate-fade flexbox-align-items">
                    <span>{{ report.navn }}</span>
                </div>
                <div @click="openReportDetails(report)" class="large-6 cell item truncate-fade flexbox-align-items">
                    <span>{{ report.beskrivelse }}</span>
                </div>
                <div class="large-1 cell item flexbox-center">
                    <div @click="downloadReport(report)" class="button-list-with-icon cursor">
                        <icon class="medium-svg fill-white" name="upload"></icon>
                    </div>
                </div>
            </div>
        </div>
    </transition-group>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '@/store/api.js'
import Modal from '@/components/modal/modal.vue'
import { ModalConfig } from '@/components/modal/modal.js'

export default {
    name: 'dashboard-reports-list',
    components: {
        Modal
    },
    props: {
        value: Array,
        selectedTab: String,
        yearSelected: [String, Number]
    },
    data () {
        return {
            reports: this.value,
            data: null,
            perPage: 10,
            reportModalConfig: null,
            selectedReport: {},
            // modal
            handlerModalConfig: null,
            handlerHeader: ''
        }
    },
    computed: {
        ...mapGetters({
            selectedReportBalanceSetting: 'getSelectedReportBalanceSetting'
        })
    },
    methods: {
        async downloadReport (report) {
            try {
                this.handlerHeader = 'Henter rapport...'
                this.handlerModalConfig.open()
                const year = this.selectedReportBalanceSetting.aar.find(aar => aar.id === this.yearSelected).aar
                const response = await axios.downloadExcel('/Value/Report/DownloadReport', {
                    balanceId: this.selectedReportBalanceSetting.id,
                    regnskabAar: year,
                    reportId: report.id
                })
                if (response) {
                    this.handlerModalConfig.close()
                    return new Promise((resolve, reject) => {
                        let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })

                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, report.navn + '.xlsx')
                            resolve(blob)
                        }

                        const data = window.URL.createObjectURL(blob, report.navn + '.xlsx')
                        var link = document.createElement('a')
                        link.href = data
                        link.download = report.navn + '.xlsx'
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)

                        resolve(blob)
                    })
                }
            } catch (err) {
                console.log('error download report', err)
                this.handlerHeader = 'Der skete en fejl ved hentning af rapporten'
                setTimeout(() => {
                    this.handlerModalConfig.close()
                }, 2500)
            }
        },
        openReportDetails (report) {
            this.selectedReport = {...report}
            this.reportModalConfig.open()
        },
        async updateReport () {
            try {
                const response = await axios.post('/Value/Report/UpdateReport', {
                    id: this.selectedReport.id,
                    navn: this.selectedReport.navn,
                    beskrivelse: this.selectedReport.beskrivelse
                })
                if (response) {
                    this.$emit('updateReportList')
                }
            } catch (err) {
                console.log('error updating report', err)
            }
        }
    },
    watch: {
        value (reports) {
            this.reports = reports
        }
    },
    created () {
        this.reportModalConfig = new ModalConfig({
            reject: 'Annuller',
            accept: 'Opdatér'
        })
        this.handlerModalConfig = new ModalConfig({})
    }
}
</script>

<style lang="scss" scoped>
.form {
  .border-bottom {
    border-bottom: 1px solid #efeded;
    padding-top: 15px;
    padding-bottom: 15px;
    position: relative;

    input {
      width: 100%;
    }
  }

  .border-bottom-last {
    border-bottom: 0px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/dashboard/dashboard-reports-list.vue